import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useMemo, useState } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useIntl } from 'react-intl-next';
import { Select } from '@atlaskit/link-create';
import { Box, xcss } from '@atlaskit/primitives';
import { GoalIcon } from '@atlassian/goals/icon';
import { queryGoalTypes } from '../../../services/goal-types-query/main';
import { isMessageId, messages } from './messages';
var GOAL_TYPE_SELECT_FIELD_NAME = 'goalTypeSelect';
var goalTypeOptionStyles = xcss({
  display: 'flex',
  gap: 'space.075',
  alignItems: 'center'
});
var hideGoalTypeStyles = xcss({
  display: 'none'
});
var getDisplayName = function getDisplayName(_ref) {
  var intl = _ref.intl,
    _ref$name = _ref.name,
    messageId = _ref$name.messageId,
    defaultValue = _ref$name.defaultValue,
    value = _ref$name.value;
  return value !== null && value !== void 0 ? value : isMessageId(messageId) ? intl.formatMessage(messages[messageId]) : defaultValue;
};
var GoalTypeLabel = function GoalTypeLabel(_ref2) {
  var goalName = _ref2.goalName,
    goalKey = _ref2.goalKey,
    intl = _ref2.intl;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: goalTypeOptionStyles
  }, /*#__PURE__*/React.createElement(GoalIcon, {
    appearance: "default",
    goalIconKey: goalKey,
    isVisualRefresh: true
  }), getDisplayName({
    intl: intl,
    name: goalName
  }));
};
export var GoalTypeSelect = function GoalTypeSelect(_ref3) {
  var defaultCloudId = _ref3.defaultCloudId,
    gatewayBaseUrl = _ref3.gatewayBaseUrl;
  var intl = useIntl();
  var siteSelectPayload = useFormState();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    goalTypeQueryError = _useState2[0],
    setGoalTypeQueryError = _useState2[1];
  var _useForm = useForm(),
    change = _useForm.change;
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    goalTypes = _useState4[0],
    setGoalTypes = _useState4[1];
  useEffect(function () {
    var _siteSelectPayload$va, _siteSelectPayload$va2, _siteSelectPayload$va3;
    var containerId = (_siteSelectPayload$va = (_siteSelectPayload$va2 = siteSelectPayload.values.site) === null || _siteSelectPayload$va2 === void 0 ? void 0 : _siteSelectPayload$va2.value.cloudId) !== null && _siteSelectPayload$va !== void 0 ? _siteSelectPayload$va : defaultCloudId;
    var siteUrl = (_siteSelectPayload$va3 = siteSelectPayload.values.site) === null || _siteSelectPayload$va3 === void 0 ? void 0 : _siteSelectPayload$va3.value.url;
    queryGoalTypes({
      containerId: containerId,
      gatewayBaseUrl: gatewayBaseUrl,
      siteUrl: siteUrl
    }).then(function (data) {
      setGoalTypes(data);
      if (data.edges.length === 0) {
        change(GOAL_TYPE_SELECT_FIELD_NAME, null);
      } else {
        var _defaultGoalType$node, _defaultGoalType$node2, _defaultGoalType$node3, _defaultGoalType$node4;
        var defaultGoalType = data.edges[0];
        var defaultGoalTypeName = (_defaultGoalType$node = (_defaultGoalType$node2 = defaultGoalType.node) === null || _defaultGoalType$node2 === void 0 ? void 0 : _defaultGoalType$node2.name) !== null && _defaultGoalType$node !== void 0 ? _defaultGoalType$node : {};
        change(GOAL_TYPE_SELECT_FIELD_NAME, {
          label: /*#__PURE__*/React.createElement(GoalTypeLabel, {
            goalName: defaultGoalTypeName,
            goalKey: (_defaultGoalType$node3 = defaultGoalType.node) === null || _defaultGoalType$node3 === void 0 || (_defaultGoalType$node3 = _defaultGoalType$node3.icon) === null || _defaultGoalType$node3 === void 0 ? void 0 : _defaultGoalType$node3.key,
            intl: intl
          }),
          value: (_defaultGoalType$node4 = defaultGoalType.node) === null || _defaultGoalType$node4 === void 0 ? void 0 : _defaultGoalType$node4.id
        });
      }
    }).catch(function (error) {
      return setGoalTypeQueryError(error);
    });
  }, [defaultCloudId, gatewayBaseUrl, siteSelectPayload.values.site, siteSelectPayload.values.cloudId, change, intl]);
  var goalTypeOptions = useMemo(function () {
    return goalTypes === null || goalTypes === void 0 ? void 0 : goalTypes.edges.map(function (goalType) {
      var _goalType$node$name, _goalType$node, _goalType$node2, _goalType$node3;
      return {
        label: /*#__PURE__*/React.createElement(GoalTypeLabel, {
          goalName: (_goalType$node$name = (_goalType$node = goalType.node) === null || _goalType$node === void 0 ? void 0 : _goalType$node.name) !== null && _goalType$node$name !== void 0 ? _goalType$node$name : {},
          goalKey: (_goalType$node2 = goalType.node) === null || _goalType$node2 === void 0 || (_goalType$node2 = _goalType$node2.icon) === null || _goalType$node2 === void 0 ? void 0 : _goalType$node2.key,
          intl: intl
        }),
        value: (_goalType$node3 = goalType.node) === null || _goalType$node3 === void 0 ? void 0 : _goalType$node3.id
      };
    });
  }, [goalTypes === null || goalTypes === void 0 ? void 0 : goalTypes.edges, intl]);
  var showGoalTypes = !goalTypeQueryError && (goalTypes === null || goalTypes === void 0 ? void 0 : goalTypes.edges) && (goalTypes === null || goalTypes === void 0 ? void 0 : goalTypes.edges.length) > 0;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: showGoalTypes ? undefined : hideGoalTypeStyles
  }, /*#__PURE__*/React.createElement(Select, {
    isRequired: true,
    name: GOAL_TYPE_SELECT_FIELD_NAME,
    label: "Type",
    inputId: "goal-create-modal-type-field",
    classNamePrefix: "react-select",
    options: goalTypeOptions,
    placeholder: intl.formatMessage(messages.goalTypeSelectPlaceholder),
    testId: "goal-type-select"
  }));
};